export const TotalCostOptimizationsActionTypes = {
    API_RESPONSE_SUCCESS: '@@total-cost-optimizations/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@total-cost-optimizations/API_RESPONSE_ERROR',
    GET_TOTAL_CHARGE_AMOUNT: '@@total-cost-optimizations/GET_TOTAL_CHARGE_AMOUNT',
    GET_TOTAL_AUDITABLE_AMOUNT: '@@total-cost-optimizations/GET_TOTAL_AUDITABLE_AMOUNT',
    GET_AVG_TOTAL_CHARGE_AMOUNT: '@@total-cost-optimizations/GET_AVG_TOTAL_CHARGE_AMOUNT',
    GET_COMPARISON_TOTAL_CHARGE_AMOUNT: '@@total-cost-optimizations/GET_COMPARISON_TOTAL_CHARGE_AMOUNT',
    GET_COMPARISON_AVG_TOTAL_CHARGE_AMOUNT: '@@total-cost-optimizations/GET_COMPARISON_AVG_TOTAL_CHARGE_AMOUNT',
    GET_TOTAL_COST_BY_WEIGHT_AND_ZONE: '@@total-cost-optimizations/GET_TOTAL_COST_BY_WEIGHT_AND_ZONE',
};
